import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import { FaCompass } from "react-icons/fa";
import { useTheme } from "../../context/ThemeContext";

import { Icon } from "../../components/common/Icon";

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();
    const { theme } = useTheme();
    const isDark = theme === "dark";

    return (
        <div className="error-page">
            <Container className="text-center">
                <div className="icon-wrapper">
                    <Icon icon={FaCompass} className="error-icon" />
                </div>
                <h1 className="error-title">Page Not Found</h1>
                <p className="error-message">
                    The page you are looking for doesn't exist or has been moved.
                    <br />
                    Let's get you back on track.
                </p>
                <Button
                    variant="primary"
                    className="action-btn"
                    onClick={() => navigate("/dashboard")}
                >
                    Go to Dashboard
                </Button>
            </Container>

            <style>{`
        .error-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: ${isDark ? "#0f172a" : "#f8fafc"};
          color: ${isDark ? "#f8fafc" : "#0f172a"};
        }

        .icon-wrapper {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: ${isDark ? "rgba(99, 102, 241, 0.1)" : "#e0e7ff"};
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
        }

        .error-icon {
          font-size: 3rem;
          color: ${isDark ? "#818cf8" : "#4f46e5"};
        }

        .error-title {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
          background: linear-gradient(135deg, #818cf8 0%, #4f46e5 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .error-message {
          font-size: 1.1rem;
          color: ${isDark ? "#94a3b8" : "#64748b"};
          margin-bottom: 2rem;
          line-height: 1.6;
        }

        .action-btn {
          padding: 0.75rem 2rem;
          border-radius: 12px;
          font-weight: 600;
          background: linear-gradient(135deg, #818cf8 0%, #4f46e5 100%);
          border: none;
          box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
          transition: all 0.3s ease;
        }

        .action-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);
        }
      `}</style>
        </div>
    );
};

export default NotFoundPage;
